import React, { useEffect, useState, useContext } from 'react'
import { DefaultContext } from '../../context/context_default';
import { useNavigate } from "react-router-dom";
import { serverTimestamp } from "firebase/firestore";
import { useAlert } from 'react-alert'

import DeckDB from '../../database/wrappers/deck';
export function useDeckBuild() {
	const {
		tipos,
		listCards,
		raridades,
		setShowCardFlutuante,
		listCardDeck,
		setListCardDeck,
		listCardDeckMatriz,
		setListCardDeckMatriz,
		quebradorDeck,
		setQuebradorDeck,
		globalFirestoreData,
		deckName,
		deck_tu_edit,
		share_deck,
		setShow_list_cards_deck, show_list_cards_deck

	} = useContext(DefaultContext);

	const navitage = useNavigate()

	const [isOpenFilter, setIsOpenFilter] = useState(false);
	const [isOpenDeck, setIsOpenDeck] = useState(false);
	const [isOpenStatsModal, setIsOpenStatsModal] = useState(false);
	const [zoom, setZoom] = useState(true);
	const [editName, setEditName] = useState(false);
	const [colapseFortuna, setColapseFortuna] = useState(false);
	const [load, setLoad] = useState(false);
	const [editMode, setEditMode] = useState(null);
	const [search, setSearch] = useState('');



	const alert = useAlert()


	const toggleDrawerFilter = () => {
		setIsOpenFilter(!isOpenFilter);
	};
	const toggleDrawerDeck = () => {
		setIsOpenDeck(!isOpenDeck);
	};
	const toggleStatsModal = (value) => {
		setIsOpenStatsModal(value !== undefined ? value : !isOpenStatsModal);
	};
	const toggleZoom = () => {
		setZoom(!zoom);
	};

	useEffect(() => {
		const mediaQuery = window.matchMedia('(max-width: 768px)'); // Defina aqui a largura que define um dispositivo móvel
		// Verifica se a tela é um celular ou não
		const checkDeviceType = (e) => {
			if (e.matches) {
				setIsOpenFilter(false); // É um celular
				setIsOpenDeck(false)
			} else {
				// setIsOpenFilter(true); // É um computador
				setIsOpenDeck(true)
			}
		};
		// Verifica a largura da tela ao carregar a página
		checkDeviceType(mediaQuery);
		// Adiciona um listener para monitorar mudanças na largura da tela
		mediaQuery.addListener(checkDeviceType);
		// Remove o listener quando o componente é desmontado
		return () => {
			mediaQuery.removeListener(checkDeviceType);
		};
	}, []);

	function addCardToDeck(cardId) {
		var card = listCards.find((e) => e.id === cardId)
		var raridade_card = raridades.find((e) => e.id === card.raridade)
		// var card = listCards.find(e => e.id === cardId)
		var flag_quebrador = false;
		if (card) {
			card.tipo.forEach(element => {
				const find_tipo = tipos.find(e => e.id === element)

				if (find_tipo.tipo === "Quebrador") {
					flag_quebrador = true
				}
			});
		}
		if (flag_quebrador) {

			setQuebradorDeck({ id: cardId, qtd: 1, card: card })
		} else {
			var aux_list = listCardDeck;

			if (aux_list.filter((e => e.id === cardId)).length > 0) {
				for (let item of aux_list) {
					if (item.id === cardId) {
						if ((raridade_card.raridade === "Lendária" && item.qtd >= 2) ||
							(raridade_card.raridade === "Rara" && item.qtd >= 3) ||
							(raridade_card.raridade === "Incomum" && item.qtd >= 4) ||
							(raridade_card.raridade === "Comum" && item.qtd >= 5)
						) {
							alert.error('Limite de copias por raridade');
							break
						}

						item.qtd += 1
					}
				}
			}
			else {
				aux_list.push(
					{ id: cardId, qtd: 1, card: card },
				)
			}
			setListCardDeck([...aux_list])
		}

	}
	function lessCardToDeck(cardId) {

		var aux_list = listCardDeck;
		if (aux_list.filter((e => e.id === cardId)).length > 0) {
			if (aux_list.find((e => e.id === cardId)).qtd <= 1) {
				aux_list = aux_list.filter((elemento) => elemento.id !== cardId);
				setShowCardFlutuante(null)
			} else {
				for (let item of aux_list) {
					if (item.id === cardId) {
						item.qtd -= 1
					}
				}
			}

		}

		setListCardDeck([...aux_list])

	}

	function addCardToDeckMatriz(cardId) {
		var card = listCards.find((e) => e.id === cardId)
		var raridade_card = raridades.find((e) => e.id === card.raridade)
		var tipo = tipos.find((e) => card.tipo.includes(e.id))

		var aux_list = listCardDeckMatriz;

		if (aux_list.filter((e => e.id === cardId)).length > 0) {
			for (let item of aux_list) {
				if (item.id === cardId) {
					if (tipo.tipo === 'Básica') { }
					else if ((raridade_card.raridade === "Lendária" && item.qtd >= 2) ||
						(raridade_card.raridade === "Rara" && item.qtd >= 3) ||
						(raridade_card.raridade === "Incomum" && item.qtd >= 4) ||
						(raridade_card.raridade === "Comum" && item.qtd >= 5)
					) {
						alert.error('Limite de copias por raridade');
						break
					}

					item.qtd += 1
				}
			}
		}
		else {
			aux_list.push(
				{ id: cardId, qtd: 1, card: card },
			)
		}

		setListCardDeckMatriz([...aux_list])
	}
	function lessCardToDeckMatriz(cardId) {

		var aux_list = listCardDeckMatriz;
		if (aux_list.filter((e => e.id === cardId)).length > 0) {
			if (aux_list.find((e => e.id === cardId)).qtd <= 1) {
				aux_list = aux_list.filter((elemento) => elemento.id !== cardId);
				setShowCardFlutuante(null)
			} else {
				for (let item of aux_list) {
					if (item.id === cardId) {
						item.qtd -= 1
					}
				}
			}

		}

		setListCardDeckMatriz([...aux_list])

	}


	function range(start, end) {
		return Array(end - start + 1).fill().map((_, idx) => start + idx)
	}

	function filtroDreck() {

		setShow_list_cards_deck(!show_list_cards_deck)
	}
	async function salveDeck() {
		setLoad(true)
		if (quebradorDeck) {
			var form = {}
			form['nome'] = deckName;
			form['arvore'] = listCardDeck;
			form['matriz'] = listCardDeckMatriz;
			form['quebrador'] = quebradorDeck.id;
			form['user_id'] = globalFirestoreData.userId;
			form['timestamp'] = serverTimestamp();
			form['share'] = share_deck;
			// form['create_at'] = moment().toString();
			const userDB = new DeckDB()
			await userDB.create(
				form
			).then((e) => {
				alert.success('Deck salvo com sucesso');
				navitage("/deck-list")

			}).catch(err => {
				alert.error('Erro ao salvar deck')
			})

		} else {
			alert.error('Selecione um Quebrador')
		}
		setLoad(false)

	}
	async function updateDeck() {
		setLoad(true);

		if (quebradorDeck && deck_tu_edit.id) {
			var form = {};
			form['nome'] = deckName;
			form['arvore'] = listCardDeck;
			form['matriz'] = listCardDeckMatriz;
			form['quebrador'] = quebradorDeck.id;
			form['timestamp'] = serverTimestamp();
			form['share'] = share_deck;
			// form['create_at'] = moment().toString();

			const userDB = new DeckDB();

			await userDB.update(deck_tu_edit.id, form) // Assumindo que você tenha um método de atualização no seu DeckDB
				.then((e) => {
					alert.success('Deck atualizado com sucesso');
					navitage("/deck-list")

				})
				.catch(err => {
					console.error(err);
					alert.error('Erro ao atualizar o deck');
				});
		} else {
			alert.error('Selecione um Quebrador');
		}

		setLoad(false);
	}

	function searchChange(event) {
		setSearch(event.target.value);
	}

	var list = range(1, 180);
	return {

		list,
		isOpenFilter,
		setIsOpenFilter,
		isOpenDeck,
		setIsOpenDeck,
		isOpenStatsModal,
		toggleStatsModal,
		toggleDrawerFilter,
		toggleDrawerDeck,
		zoom,
		toggleZoom,
		setZoom,
		listCardDeck,
		setListCardDeck,
		listCardDeckMatriz,
		setListCardDeckMatriz,
		addCardToDeck,
		lessCardToDeck,
		addCardToDeckMatriz,
		lessCardToDeckMatriz,

		editName,
		setEditName,
		colapseFortuna,
		setColapseFortuna,
		salveDeck,
		updateDeck,
		setQuebradorDeck,
		quebradorDeck,
		load,
		search,
		searchChange,
		editMode,
		setEditMode,
		filtroDreck

	}
}